import React, { useState, useEffect } from 'react';
import { Col, Dropdown, Button } from 'antd';
import { MoreOutlined } from '@ant-design/icons';
import { Logo } from '../Logo';
import { Popover } from '@/components/Layout/Popover';
import { useApplicationContext } from '@/context/v1/Application/context';
import { SelectProject } from '@/components/SelectProject';
import { ProjectSelect } from '@/components/Layout/ProjectSelect';
import { Container, ContainerRow, ContainerDiv, ContainerDivOptions, MobileMenuContainer } from './styles';

export const Header: React.FC = () => {
	const { isSandbox } = useApplicationContext();
	const [isMobile, setIsMobile] = useState(false);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 700);
		};

		handleResize();
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	const styles = {
		border: 'none',
		color: isSandbox ? 'white' : '',
		backgroundColor: isSandbox ? '#002FBB' : ''
	};

	const menuItems = [
		{
			key: 'project-select',
			label: <div style={{ color: isSandbox ? 'white' : 'inherit' }}><ProjectSelect /></div>,
		},
		{
			key: 'select-project',
			label: <div style={{ color: isSandbox ? 'white' : 'inherit' }}><SelectProject /></div>,
		},
	];

	return (
		<Container style={styles}>
			<ContainerRow gutter={14} align="middle">
				<ContainerDiv>
					<Col>
						<Logo />
					</Col>
				</ContainerDiv>
				{isMobile ? (
					<MobileMenuContainer>
						<Col>
							<Popover />
						</Col>
						<Dropdown
							menu={{
								items: menuItems,
								style: {
									backgroundColor: isSandbox ? '#002FBB' : '#fff',
								}
							}}
							placement="bottomRight"
							trigger={['click']}
						>
							<Button
								type="text"
								icon={<MoreOutlined style={{ fontSize: '20px', color: isSandbox ? 'white' : '#000' }} />}
								size="large"
							/>
						</Dropdown>
					</MobileMenuContainer>
				) : (
					<ContainerDivOptions>
						<Col>
							<ProjectSelect />
						</Col>
						<Col>
							<Popover />
						</Col>
						<Col>
							<SelectProject />
						</Col>
					</ContainerDivOptions>
				)}
			</ContainerRow>
		</Container>
	);
};
